module.exports = __webpack_public_path__ + "assets/wenjian.efc74afe0928be929879b8b6bce801ae.png";